import { saveBanding, savebranchDetails } from "../maintenance-branch-interface/maintenance-branch-interface";

export class BranchNamemodel {

  private savebranchdetails!: savebranchDetails[];
 

  constructor() { }

  //Getters & Setters
  getsavebranch() {
    return this.savebranchdetails;
  }

  setsavebranch(data: savebranchDetails[]) {
    this.savebranchdetails = data;
  }


}
